<template>
  <div id="page-container" class="scroll">
   <!-- <preloader-view /> -->
    <div  :class="$route.fullPath.startsWith('/bok') ? '' : 'md:pb-80 pb-24'">
      <router-view :key="$route.fullPath" />
    </div>
    <div
    v-show="$route.meta.footer"
      id="footer"
      class="fixed md:absolute bottom-0 left-0 w-full md:h-72 h-20 z-50"
    >
      <footer-view />
    </div>
  </div>
</template>
<script>
import FooterView from './components/shared/FooterView.vue'
// import PreloaderView from './components/shared/PreloaderView.vue';
import * as Sentry from "@sentry/vue";

export default {
  components: {
    FooterView,
    // PreloaderView,
  },
  data () {
    return {
      currentTime: 0,
      show: false,
      registration: null,
      isRefresh: false,
      refreshing: false
    }
  },





  created() {
    document.addEventListener("serviceWorkerUpdateEvent", this.appUpdateUI, {
      once: true,
    });
    
    // Prevent PWA install prompt
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the browser from showing the default PWA install prompt
      e.preventDefault();
      // Optionally log that the prompt was prevented
      console.log('PWA install prompt prevented');
      return false;
    });
   
  },
  methods: {
    closeUpdata () {
      this.isRefresh = false
    },
    appUpdateUI (e) {
      this.registration = e.detail
      this.isRefresh = true
    },
    update() {
      this.isRefresh = false;

      if (this.registration || this.registration.waiting !=null) {
        this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
      
        this.forceUpdate();
    },
    forceUpdate(){
      window.location.reload(true);
    },
    
    // Sentry testing methods (for development only)
    testSentryError() {
      if (process.env.NODE_ENV === 'development') {
        Sentry.captureMessage('Testing Sentry integration from App.vue', 'info');
        console.log('Sentry test message sent');
        
        // Uncomment to test error capture:
        // throw new Error('Test error from App.vue');
      }
    },
    testSentryMetrics() {
      if (process.env.NODE_ENV === 'development') {
        Sentry.metrics.count('app_test_counter', 1, {
          tags: { component: 'App.vue' }
        });
        console.log('Sentry metrics test sent');
      }
    }
  },
};
</script>
<style>
.text-color {
  color: #9d2890;
}
.btn-color {
  background-color: #9d2890;
}

.border-color {
  border-color: #9d2890 !important;
}
.order-btn {
  background-color: #191a2c;
}
.card-bg {
  background-color: #15182b;
}
.btn-color-orange {
  background-color: #d5573b;
}
#page-container {
  position: relative;
  min-height: 100vh;
}


*:focus {
  outline: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
/* input.form-control {
    text-align: center;
    height: 60px;
  } */
</style>
